import React from 'react';
import Offcanvas from 'olive-react-myoneui/lib/Offcanvas';
import Nav from 'olive-react-myoneui/lib/Nav';
import Tab from 'olive-react-myoneui/lib/Tab';
import Button from 'olive-react-myoneui/lib/Button';
import { uptrendIcon } from '../../../constants/icons';
import ActivityLogs from './ActivityLogs';

function ActivityLogsOffcanvas({ showActivityLogOffcanvas, setShowActivityLogOffcanvas, activityLogs }) {
    const handleClose = () => setShowActivityLogOffcanvas(false);
    const offCanvasKeyDown = (e) => e.stopPropagation();

    return (
        <Offcanvas show={showActivityLogOffcanvas} onHide={handleClose} placement="end" className="pb-0" onKeyDown={offCanvasKeyDown}>
        <Offcanvas.Header closeButton backButton="Back" className="pb-4 ps-4 messages-header myk__stu-doc_offcanvas-header">
            <Offcanvas.Title>{activityLogs && activityLogs.item_name ? activityLogs.item_name : 'File Name'}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="pt-0 ps-4 pe-0 pb-0">
            <Tab.Container id="left-tabs-example" activeKey="activity_logs">
            <Nav variant="pills">
                <Nav.Item>
                <Nav.Link eventKey="activity_logs">Activity Logs</Nav.Link>
                </Nav.Item>
            </Nav>
            <Tab.Content>
                <Tab.Pane className="myk__stu-doc-tabscontent" eventKey="activity_logs">
                <div className="myk__stu-doc_file-header">
                    <h4>{uptrendIcon} <span>Activity Logs</span></h4>
                </div>
                {
                    activityLogs ? <ActivityLogs  logs={activityLogs}/> : 'No Logs Found!'
                }
                
                </Tab.Pane>
            </Tab.Content>
            </Tab.Container>
        </Offcanvas.Body>
        <Offcanvas.Footer>
            <Button variant="default" onClick={handleClose}>Close</Button>
        </Offcanvas.Footer>
        </Offcanvas>      
    );
}

export default ActivityLogsOffcanvas;
